import GuardAuthenticationStatus from "hooks/GuardAuthenticationStatus";
import React from "react";
import { Link, Route, Switch } from "react-router-dom";
import NavBar from "ui/home/NavBar";
import Dashboard from "ui/home/Dashboard";
import Onboarding from "./Onboarding";
import Balance from "./Balance";
import BalanceMinutes from "./BalanceMinutes";
import BalanceMinutesSell from "./BalanceMinutesSell";
import BalanceMinutesSalesRecord from "./BalanceMinutesSalesRecord";
import BalanceMinutesOrder from "./BalanceMinutesOrder";
import BalanceMinutesOrdersRecord from "./BalanceMinutesOrdersRecord";
import BalanceMoney from "./BalanceMoney";
import styles from "./HomeRoot.module.scss";
import Home from "./Home";
import Settings from "./Settings";
import BalanceMoneyCreateTransfer from "./BalanceMoneyCreateTransfer";
import BalanceMoneyTransfersRecord from "./BalanceMoneyTransfersRecord";
import BalanceMoneyAdd from "./BalanceMoneyAdd";
import DesktopLogin from "./DesktopLogin";
import NotFound from "./NotFound";
import AccountSetup from "./AccountSetup";
import Feedback from "./Feedback";
import classnames from "classnames";
import CreateJob from "./CreateJob";
import FileList from "./FileList";
import JobDetail2 from "./JobDetail2";
import Teams from "./Teams";
import TeamDetail from "./TeamDetail";

const HomeRoot: React.FC = () => {
    GuardAuthenticationStatus("authenticated");

    return (
        <>
            <div>
                <NavBar />
                <div className={styles.spacer} />
                <Switch>
                    <Route exact={true} path="*/account-setup">
                        <AccountSetup />
                    </Route>
                    <Route exact={true} path="*/desktop-login">
                        <DesktopLogin />
                    </Route>
                    <Route exact={true} path="*/dashboard">
                        <Dashboard />
                    </Route>
                    <Route exact={true} path="*/dashboard/jobs/:jobId">
                        <JobDetail2 />
                    </Route>
                    <Route exact={true} path="*/dashboard/onboarding">
                        <Onboarding />
                    </Route>
                    <Route
                        exact={true}
                        path="*/dashboard/balance/minutes/sales-record"
                    >
                        <BalanceMinutesSalesRecord />
                    </Route>
                    <Route
                        exact={true}
                        path="*/dashboard/balance/minutes/orders-record"
                    >
                        <BalanceMinutesOrdersRecord />
                    </Route>
                    <Route
                        exact={true}
                        path="*/dashboard/balance/minutes/order"
                    >
                        <BalanceMinutesOrder />
                    </Route>
                    <Route exact={true} path="*/dashboard/balance/minutes/sell">
                        <BalanceMinutesSell />
                    </Route>
                    <Route exact={true} path="*/dashboard/balance/minutes">
                        <BalanceMinutes />
                    </Route>
                    <Route exact={true} path="*/dashboard/balance/money">
                        <BalanceMoney />
                    </Route>
                    <Route exact={true} path="*/dashboard/balance">
                        <Balance />
                    </Route>
                    <Route exact={true} path="*/files">
                        <FileList />
                    </Route>
                    <Route exact={true} path="*/files/create-job/:fileId">
                        <CreateJob />
                    </Route>
                    <Route exact={true} path="*/settings">
                        <Settings />
                    </Route>
                    <Route exact={true} path="/home">
                        <Home />
                    </Route>
                    <Route
                        exact={true}
                        path="*/dashboard/balance/money/transfer"
                    >
                        <BalanceMoneyCreateTransfer />
                    </Route>
                    <Route
                        exact={true}
                        path="*/dashboard/balance/money/view-transfers"
                    >
                        <BalanceMoneyTransfersRecord />
                    </Route>
                    <Route exact={true} path="*/dashboard/balance/money/add">
                        <BalanceMoneyAdd />
                    </Route>
                    <Route exact={true} path="*/home/teams">
                        <Teams />
                    </Route>
                    <Route exact={true} path="*/home/teams/team/:teamId">
                        <TeamDetail />
                    </Route>
                    <Route exact={true} path="*/feedback">
                        <Feedback />
                    </Route>
                    <Route path="">
                        <NotFound />
                    </Route>
                </Switch>
            </div>
            <Link
                to="/home/feedback"
                className={classnames(styles.bugButton, "btn", "btn-light")}
            >
                Feedback or Bugs?
            </Link>
        </>
    );
};

export default HomeRoot;
